import { render, staticRenderFns } from "./book-contributors.vue?vue&type=template&id=5ffeba62&scoped=true&"
import script from "./book-contributors.vue?vue&type=script&lang=js&"
export * from "./book-contributors.vue?vue&type=script&lang=js&"
import style0 from "./book-contributors.vue?vue&type=style&index=0&id=5ffeba62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffeba62",
  null
  
)

export default component.exports